import { memo } from "react";

import { useLocalization } from "@fluent/react";
import { Row } from "@narmi/design_system";

import styles from "../SearchBar.module.scss";

import { SearchBarIcon, SearchBarShortcutDisplay } from "./SearchBar.Misc";

const SearchBarCollapsed = () => {
  const { l10n } = useLocalization();
  const placeholderText = l10n.getString("search-bar-collapsed-placeholder");

  return (
    <Row className={styles["search-bar"]} alignItems="center" gapSize="xs">
      <SearchBarIcon />
      <Row.Item className={styles["single-line-text"]}>
        {placeholderText}
      </Row.Item>
      <SearchBarShortcutDisplay />
    </Row>
  );
};

export default memo(SearchBarCollapsed);
